// extracted by mini-css-extract-plugin
export default {"content":"SetPasswordScreen_content__S4FsB","dialog":"SetPasswordScreen_dialog__Lbv-F","form":"SetPasswordScreen_form__YThf8"};